import ESIPage from "@/components/esi-page/ESIPage";
import { capitalize } from "lodash";

function generateMetadata(params) {
  const title = params.slug?.[0]?.split("-").map(capitalize).join(" ");
  return {
    title: title || "Ordering and returning products",
    description:
      "Manage your order with ease. Track your purchase, view history, and learn how to change, cancel, or report a missing, incomplete, or damaged order.",
  };
}

function Page() {
  return <ESIPage />;
}

Page.generateMetadata = generateMetadata;

export default Page;
